import { render } from "./App.vue?vue&type=template&id=0e75fa4c"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=0e75fa4c&lang=css"
script.render = render

export default script